// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".inner[data-v-2efcd65c]{text-align:center}.inner[data-v-2efcd65c]  .btn-general{margin-bottom:5rem}.sub-message[data-v-2efcd65c]{background-color:#f5f5f5;padding:20px 0;font-style:italic}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
